import { defineMessages } from 'react-intl';

export const panelEditorMessages = defineMessages({
  display: {
    id: 'display',
    defaultMessage: 'Display'
  },
  default: {
    id: 'default',
    defaultMessage: 'Default'
  },
  browserDoesNotSupportVideo: {
    id: 'browserDoesNotSupportVideo',
    defaultMessage: 'Browser does not support video elements.'
  }
});
